import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React from "react";
import SwitchCheckbox from "../../../global/content/SwitchCheckbox";

const MantPermissionComponent = ( {title, idEdit, createData, closeSection, idRef, componentes, icon, showCreate, showEdit}) => {
    const { handleSubmit, reset, formState: { errors } } = useForm({mode: "onChange"});
    // const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const onSubmit1 = (form) => {
        let arrElements = [];
        componentes.map(cmp => {
            cmp.permisos.map(perm => {
                if (cmp.componente.enlaceInterno != '#') {
                    let check = document.getElementById(`chk_${cmp.componente.id}_${perm.id}`)
                    console.log(`key: ${cmp.componente.id}_${perm.id}, name: ${cmp.componente.nombre}_${perm.nombre} -> ${check.checked}`);
                    
                    if (check.checked) {    
                        arrElements.push({'permisoId': perm.id, 'componenteId': cmp.componente.id})
                    }
                }
            })
        });
        // console.log('arrElements', arrElements);
        createData(arrElements);
    };

    const loadForm = (object) => {
        // setValue('nombre', object.nombre);
        // setValue('descripcion', object.descripcion);
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                            <div className="row">
                                {componentes.map((cmp, index) => (
                                    <React.Fragment key={`frag_${cmp.componente.id}__${index}`}>
                                        {cmp.componente.enlaceInterno != '#' && <div className="col-sm-12 col-md-12 pb-3 pt-2 border-bottom">
                                            <h4>{cmp.componente.nombre}</h4>
                                            <div className="row">
                                                {cmp.permisos.map((perm) => (
                                                    <React.Fragment key={`column_${cmp.componente.id}__${perm.id}`}>
                                                        <div className="col-sm-12 col-md-3">
                                                            <SwitchCheckbox label={`Permitir ${perm.nombre}`} name={`chk_${cmp.componente.id}_${perm.id}`} checked={perm.estadoId == 'Y'?true:false} />
                                                        </div>
                                                    </React.Fragment> 
                                                ))}
                                            </div>
                                        </div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-3 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && showEdit && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantPermissionComponent;